import { render } from "./Attribute.vue?vue&type=template&id=a74f8d74&scoped=true"
import script from "./Attribute.vue?vue&type=script&lang=js"
export * from "./Attribute.vue?vue&type=script&lang=js"

import "./Attribute.vue?vue&type=style&index=0&id=a74f8d74&lang=scss&scoped=true"

import exportComponent from "/Users/flegate/Serveur/Sites/welcom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a74f8d74"]])

export default __exports__